import type { JSX } from "react";
import { Toggle } from "@mailflare/ui";

export interface SearchFilterState {
  readonly isUnread: boolean;
  readonly hasAttachment: boolean;
}

export interface FilterChipsProps {
  readonly value: SearchFilterState;
  readonly onChange: (next: SearchFilterState) => void;
}

interface ChipConfig {
  readonly key: keyof SearchFilterState;
  readonly label: string;
}

const CHIPS: readonly ChipConfig[] = [
  { key: "isUnread", label: "Unread" },
  { key: "hasAttachment", label: "Has attachment" },
];

/** Toggleable search filters built on the shadcn Toggle primitive. */
export function FilterChips({ value, onChange }: FilterChipsProps): JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-2" aria-label="Search filters">
      {CHIPS.map((chip) => (
        <Toggle
          key={chip.key}
          variant="outline"
          size="sm"
          pressed={value[chip.key]}
          onPressedChange={(next) => onChange({ ...value, [chip.key]: next })}
          data-testid={`filter-${chip.key}`}
          aria-label={chip.label}
        >
          {chip.label}
        </Toggle>
      ))}
    </div>
  );
}
